<template>
  <div>
      <form @submit.prevent="submitForm()">
        <div class="row">
            <div class="col-sm-12">
                <div class="page-title-box">
                <div class="float-right">
                    <ol class="breadcrumb">
                    <li class="breadcrumb-item"><a href="javascript:void(0);">BPD BALI</a></li>
                    <li class="breadcrumb-item active">Unit</li>
                    <li class="breadcrumb-item active">{{ $route.name == 'instanceUnitCreate' ? 'Tambah' : 'Edit' }}</li>
                    </ol>
                </div>

                <h4 class="page-title">
                    <router-link :to="{ name: 'instanceUnit' }" :disabled="loading">
                        <i class="fas fa-arrow-left mr-2"></i>
                    </router-link>
                    Unit
                </h4>
                </div>
            </div>
        </div>

        <div class="card card-loader d-flex" v-if="loadingInitial">
            <div class="justify-content-center">
                <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                    <span class="sr-only">Loading...</span>
                </div>
                <p class="mt-2">Loading</p>
            </div>
        </div>

        <div v-else>
            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <div class="form-group" :class="{ 'is-invalid': $v.form.name.$error }">
                                <label>Nama Unit</label>
                                <input type="text" class="form-control" v-model="form.name">
                                <div class="error" v-if="!$v.form.name.required">Nama Unit wajib diisi</div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group" :class="{ 'is-invalid': $v.form.location.$error }">
                                <label>Lokasi</label>
                                <input type="text" class="form-control" v-model="form.location">
                                <div class="error" v-if="!$v.form.location.required">Lokasi wajib diisi</div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group" :class="{ 'is-invalid': $v.form.position_1_name.$error }">
                                <label>Custom Jabatan 1</label>
                                <input type="text" class="form-control" v-model="form.position_1_name">
                                <div class="error" v-if="!$v.form.position_1_name.required">Custom Jabatan 1 wajib diisi</div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label>Custom Jabatan 2</label>
                                <input type="text" class="form-control" v-model="form.position_2_name">
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group">
                                <label>Custom Jabatan 3</label>
                                <input type="text" class="form-control" v-model="form.position_3_name">
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group" :class="{ 'is-invalid': $v.form.placeman_name.$error }">
                                <label>Nama Pejabat</label>
                                <input type="text" class="form-control" v-model="form.placeman_name">
                                <div class="error" v-if="!$v.form.placeman_name.required">Nama Jabatan wajib diisi</div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group" :class="{ 'is-invalid': $v.form.placeman_position.$error }">
                                <label>Golongan Pejabat</label>
                                <input type="text" class="form-control" v-model="form.placeman_position">
                                <div class="error" v-if="!$v.form.placeman_position.required">Golongan Jabatan wajib diisi</div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group" :class="{ 'is-invalid': $v.form.nip.$error }">
                                <label>NIP</label>
                                <input type="text" class="form-control" v-model="form.nip">
                                <div class="error" v-if="!$v.form.nip.required">NIP wajib diisi</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <button class="btn btn-success waves-effect waves-light mb-3" style="margin-top: 20px;" :disabled="loading">
                Simpan Unit
                <div class="spinner-border text-light ml-2" role="status" v-if="loading">
                    <span class="sr-only">Loading...</span>
                </div>
            </button>
        </div>
      </form>
  </div>
</template>

<script>
    import Swal from 'sweetalert2'
    import draggable from 'vuedraggable'
    import { required, minLength } from 'vuelidate/lib/validators'

    export default {
        data() {
            return {
                loadingInitial: false,
                loading: false,

                form: {
                    name: null,
                    location: null,
                    position_1_name: null,
                    position_2_name: null,
                    position_3_name: null,
                    placeman_name: null,
                    nip: null
                }
            };
        },
        validations: {
            form: {
                name: {required},
                location: {required},
                position_1_name: {required},
                placeman_name: {required},
                placeman_position: {required},
                nip: {required}
            }
        },
        components: {
            draggable
        },
        computed: {
            dragOptions() {
                return {
                    animation: 200,
                    group: "description",
                    disabled: false,
                    ghostClass: "ghost"
                };
            },
            classButton() {
                return this.masterData.items.length > 1 ? 'btn-danger' : 'btn-info'
            }
        },
        methods: {
            submitForm() {
                if (this.$v.$invalid) {
                    this.$v.$touch()
                    this.sAlert('error', 'Harap isi semua form dengan benar!')
                    return
                }

                this.loading = true

                let url, method, alertSuccess
                if(this.$route.name == 'instanceUnitCreate') {
                    url = `company/unit/store`
                    method = 'POST',
                    alertSuccess = 'Berhasil membuat unit baru!'
                }else{
                    url = `company/unit/update/${this.$route.params.id}`
                    method = 'PUT',
                    alertSuccess = 'Berhasil mengupdate unit!'
                }

                this.$http({
                    method,
                    url: `${this.API_URL}${url}`,
                    data: this.form,
                    headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
                })
                .then(response => {
                    const result = response.data;
                    
                    if(result.success) {
                        this.sAlert('success', alertSuccess)
                        this.$router.push({ name: 'instanceUnit' });
                    }else {
                        this.sAlert('error', result.message)
                    }
                    this.loading = false;
                })
                .catch(error => {
                    this.loading = false;
                    this.sAlert('error', "Error, Terjadi Kesalahan!")
                });
            }
        },
        mounted() {
            if(this.$route.name == 'instanceUnitEdit'){
                this.loadingInitial = true

                this.$http.get(`${this.API_URL}company/unit/${this.$route.params.id}`, {
                    headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
                })
                .then(response => {
                    this.loadingInitial = false

                    const result = response.data;
                    
                    if(result.success) {
                        this.form = response.data.data
                    }else {
                        this.sAlert('error', result.message)
                    }
                    this.loading = false;
                })
                .catch(error => {
                    this.loadingInitial = false;
                    this.sAlert('error', "Error, Terjadi Kesalahan!")
                });
            }
        }
    }
</script>